import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SnackbarErrorComponent } from '@biz-ui/shared-presenters/custom-snackbar/snackbar-error/snackbar-error.component';

@Injectable({
  	providedIn: 'root'
})
export class AppService {
	public errors = [];
	public data: any = {};
	public cloading: any = {};

	constructor(
		private _snackBar: MatSnackBar,
	) { }

	hasError(err, from = 'all') {
		this.errors[from] = [];

		delete err.error.code_status;

		if (err.status === 400) {
			this.alert(err.error.message);
		}
		else if (err.status === 401) {
			//this.rmLocal('token');
			//this.router.navigate(['login']);
		}
		else if (err.status === 422) {
			this.errors[from] = err.error;
		}
	}

	alert(msg, title = 'Oops!') {
		// Swal.fire(title, msg, 'error')
		this._snackBar.openFromComponent(SnackbarErrorComponent, {
			data: msg,
			panelClass: 'bg-danger',
		});
	}
}
